import type { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import type { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import type { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"
import { word } from "@modules/core/utils/i18n"
import { ScoreboardIndivView } from "@modules/scores/scoreboard/components/scoreboardIndivView"
import { ScoreboardView } from "@modules/scores/scoreboard/components/scoreboardView"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"

export const useScoreboardSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToScoreboardView = (
    session: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity,
  ) => {
    void sidebarNavigateTo({
      content: <ScoreboardView session={session} />,
      leftButtonText: word("program.planning.create.exercise.returnSession"),
    })
  }

  const navigateToScoreboardIndivView = (
    session: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity,
    selectedExercise: SessionBlockExerciseEntity,
    athleteId: string,
  ) => {
    void sidebarNavigateTo({
      content: (
        <ScoreboardIndivView session={session} initialSelectedExercise={selectedExercise} athleteId={athleteId} />
      ),
    })
  }

  return {
    navigateToScoreboardView,
    navigateToScoreboardIndivView,
  }
}
